interface Option {
  name: string
}

const sortByName = ({ name: a }: Option, { name: b }: Option): number => {
  if (a > b) {
    return 1
  } else if (a < b) {
    return -1
  }

  return 0
}

export { sortByName }
